import * as types from './types';

const initialState = {
  posting: [],
  publisher: {},
  loading: 'loading',
  id: {}
};

const InfoSeekerReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_SEEKER_INFO:
      state.loading = 'loading';
      state.publisher = [];
      state.posting = [];
      return { ...state };

    case types.FETCH_SEEKER_INFO_SUCCEEDED:
      state.loading = 'loaded';
      state.publisher = action.payload.publisher;
      state.posting = action.payload.posting;
      state.id = action.payload.id;
      return { ...state };

    default:
      return { ...state };
  }
};

export default InfoSeekerReducer;
